import { STATIC_SITEMAP_MANIFEST } from './static-sitemap-manifest'

// These routes render their primary content from committed files. Live catalog
// routes must resolve freshness from their rendered data instead.
export const STATIC_CONTENT_HEADER_PATHS = [
  '/about-us/fin', '/about-us/fpn', '/about-us/ffn', '/about-us/fis',
  '/contact', '/faq', '/privacy-policy', '/terms-of-service',
  '/about-us/limitations', '/about-us/methodology', '/about-us/data-sources',
  '/financing', '/warranty', '/retailer-policies',
] as const

const allowed = new Set<string>(STATIC_CONTENT_HEADER_PATHS)
export function staticContentLastmod(path: string): string | null {
  if (!allowed.has(path)) return null
  return recordedCodeLastmod(path)
}

/**
 * FRIDGE-903 — the manifest's git-guarded code revision for ANY `code` entry,
 * for a page whose main schema node should state the same date static.xml
 * emits but whose body mixes in live data, so it stays OUT of the
 * Last-Modified header allowlist above (a validator must describe the whole
 * response; a schema date describes the committed content). Null for a live
 * kind or an unlisted path — omit, never guess.
 */
export function recordedCodeLastmod(path: string): string | null {
  const entry = STATIC_SITEMAP_MANIFEST.find(row => row.path === path)
  if (!entry || entry.source !== 'code') return null
  const timestamp = Date.parse(entry.lastmod)
  return Number.isFinite(timestamp) ? new Date(timestamp).toISOString() : null
}
